
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productSlug]",
      function () {
        return require("private-next-pages/products/[productSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productSlug]"])
      });
    }
  